import { ReactNode, useContext } from 'react';
import { Card } from 'react-bootstrap';
import { AppContext } from '../../common/context/Provider';
import { ACTIONS } from '../../constants';
import { getActionService } from '../../utils/getActionService';

interface Props {
    children: ReactNode;
}

export function RequireAuditModuleAccess({ children }: Props) {
    const { userInfo } = useContext(AppContext);

    const allowed = getActionService(userInfo.actions, ACTIONS['audit.module.access']);

    if (!allowed) {
        return (
            <div className='main-content'>
                <div className='page-content'>
                    <div className='container-fluid'>
                        <Card className='mt-4 border-warning'>
                            <Card.Body>
                                <h5 className='text-warning'>Acceso denegado</h5>
                                <p className='mb-0'>
                                    No tiene permiso para acceder al módulo de auditoría. Si necesita
                                    visualizar el historial de cambios, solicite la acción «
                                    {ACTIONS['audit.module.access']}» en su perfil de seguridad.
                                </p>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </div>
        );
    }

    return <>{children}</>;
}
